import React, { useState } from 'react';

function StepSeven({ formData, onNext }) {
    const [isRegistered, setIsRegistered] = useState(formData.isRegistered || '');
    const [regulatoryBody, setRegulatoryBody] = useState(formData.regulatoryBody || '');
    const [membershipNumber, setMembershipNumber] = useState(formData.membershipNumber || '');
    const [expiryDate, setExpiryDate] = useState(formData.expiryDate || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!isRegistered) {
            setError('Please select Yes or No.');
            return;
        }

        if (
            isRegistered === 'yes' &&
            (!regulatoryBody.trim() || !membershipNumber.trim() || !expiryDate)
        ) {
            setError('Please fill out all required fields for professional registration.');
            return;
        }

        setError('');
        onNext({
            isRegistered,
            regulatoryBody,
            membershipNumber,
            expiryDate,
        });
    };

    const isFormValid =
        isRegistered === 'no' ||
        (isRegistered === 'yes' &&
            regulatoryBody.trim() &&
            membershipNumber.trim() &&
            expiryDate);

    return (
        <div className="step-form">
            <h6 className="mb-4">Membership of Professional Bodies</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <p>Are you registered with a professional body (e.g. GPhC, NMC, other)? <span className="text-danger">*</span></p>

            <div className="row">
                <div className="col-lg-6">
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="registered"
                            id="registeredYes"
                            value="yes"
                            checked={isRegistered === 'yes'}
                            onChange={() => setIsRegistered('yes')}
                        />
                        <label className="form-check-label" htmlFor="registeredYes">
                            Yes
                        </label>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="registered"
                            id="registeredNo"
                            value="no"
                            checked={isRegistered === 'no'}
                            onChange={() => setIsRegistered('no')}
                        />
                        <label className="form-check-label" htmlFor="registeredNo">
                            No
                        </label>
                    </div>
                </div>
            </div>

            {isRegistered === 'yes' && (
                <div className="row">
                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label className='mb-1'>Name of Regulatory Body</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Name of Regulatory Body"
                                value={regulatoryBody}
                                onChange={e => setRegulatoryBody(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label className='mb-1'>Membership / Registration Number</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Membership / Registration Number"
                                value={membershipNumber}
                                onChange={e => setMembershipNumber(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="mb-3">
                            <label className='mb-1'>Expiry / Renewal Date</label>
                            <input
                                type="date"
                                className="form-control"
                                placeholder="Expiry / Renewal Date"
                                value={expiryDate}
                                onChange={e => setExpiryDate(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepSeven;
